<template>
  <el-dialog title="Lançamento" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="500px">
    <el-form ref="form" size="small" :model="lancamentoSelecionado" :rules="validacao" label-position="top" hide-required-asterisk :show-message="false" style="padding:0;">

      <el-row :gutter="10">
          <el-col :span="24">
              <el-form-item prop="tipo" label="Tipo">
                  <el-select style="width:100%;" v-model="lancamentoSelecionado.tipo" :disabled="isLancamentoEfetuado">
                      <el-option v-for="item in tiposLancamento" :key="item.data" :label="item.label" :value="item.data"/>
                  </el-select>
              </el-form-item>
          </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFormCheque">
        <el-col :span="6">
          <el-form-item label="Banco" prop="bancoCheque">
            <el-select :disabled="isLancamentoEfetuado" v-model="lancamentoSelecionado.bancoCheque" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in bancos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Agência" prop="agenciaCheque">
            <el-input :disabled="isLancamentoEfetuado" size="small" v-model="lancamentoSelecionado.agenciaCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Nº Cheque" prop="numeroCheque">
            <el-input :disabled="isLancamentoEfetuado" size="small" v-model="lancamentoSelecionado.numeroCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="dataDepositoIsVisible">
          <el-form-item label="Depósito" prop="dataDeposito">
            <el-date-picker
              v-model="lancamentoSelecionado.dataDeposito"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
              :disabled="isLancamentoEfetuado"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
          <el-col :span="12">
              <el-form-item prop="dataVencimento" label="Dt. Vencimento">
                  <el-date-picker
                    v-model="lancamentoSelecionado.dataVencimento"
                    v-mask="'##/##/####'"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    style="width: 100%"
                    :disabled="remessaIsGerada || isLancamentoEfetuado"
                  />
              </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!lancamentoIsNovo">
              <el-form-item prop="dataPagamento" label="Dt. Pagamento">
                  <el-date-picker
                    v-model="lancamentoSelecionado.dataPagamento"
                    v-mask="'##/##/####'"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    style="width: 100%"
                    :disabled="isLancamentoEfetuado"
                  />
              </el-form-item>
          </el-col>
      </el-row>

      <el-row :gutter="20">
          <el-col :span="12">
              <el-form-item prop="valor" label="Valor">
                  <div class="el-input el-input--small">
                      <money auto-complete="off" v-model="lancamentoSelecionado.valor" v-bind="money" class="el-input__inner" :readonly="remessaIsGerada || isLancamentoEfetuado"/>
                  </div>
              </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!lancamentoIsNovo">
              <el-form-item prop="valorPago" label="Valor Pago">
                  <div class="el-input el-input--small">
                      <money auto-complete="off" v-model="lancamentoSelecionado.valorPago" v-bind="money" class="el-input__inner" :readonly="isLancamentoEfetuado"/>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>

      <el-row :gutter="10" v-if="!lancamentoIsNovo">
          <el-col :span="19">
              <el-form-item label="Conta da imobiliária" prop="nomecontaBancaria">
                  <el-input v-model="nomeContaBancaria" readonly style="width: 100%"/>
              </el-form-item>
          </el-col>
          <el-col :span="4">
              <el-form-item label=" ">
                  <el-button @click="exibirSelecionarContaBancariaDialog()" round type="primary" size="small" v-if="!remessaIsGerada" class="btn-box-shadow">Selecionar</el-button>
              </el-form-item>
          </el-col>
      </el-row>

      <el-row :gutter="24" v-if="isExibirInstrucoes">
        <el-col :span="24">
          <el-form-item label="Instruções 1">
            <el-input v-model="lancamentoSelecionado.instrucoes1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="isExibirInstrucoes">
        <el-col :span="24">
          <el-form-item label="Instruções 2">
            <el-input v-model="lancamentoSelecionado.instrucoes2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="isExibirInstrucoes">
        <el-col :span="24">
          <el-form-item label="Instruções 3">
            <el-input v-model="lancamentoSelecionado.instrucoes3"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="isExibirInstrucoes">
        <el-col :span="24">
          <el-form-item label="Instruções 4">
            <el-input v-model="lancamentoSelecionado.instrucoes4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Observações">
            <el-input
              v-model="lancamentoSelecionado.observacoes"
              type="textarea"
              style="height: 100%"
              class="obs-text-area "
              :readonly="disableObsevacoes"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-row style="height: 100%">
        <el-col :span="12" style="height: 100%">
          <el-row type="flex" justify="start" style="padding-top: 0px;">
            <el-button @click="pagarHandler()" round v-if="exibirBotaoPagar" type="primary" size="small" class="btn-box-shadow">Pagar</el-button>
            <el-button @click="devolverHandler()" round v-if="exibirBotaoDevolver" type="primary" size="small" class="btn-box-shadow">Devolver</el-button>
            <el-button @click="cancelarPagamentoHandler()" round v-if="exibirBotaoCancelar" type="primary" size="small" class="btn-box-shadow">Cancelar Pagamento</el-button>
          </el-row>
        </el-col>
        <el-col :span="!exibirBotaoPagar && !exibirBotaoDevolver && !exibirBotaoCancelar ? 24 : 12" style="height: 100%">
          <el-row type="flex" justify="end" style="padding-top: 0px;">
            <el-button @click="gravarHandler()" round v-if="exibirBotaoGravar" type="primary" size="small" class="btn-box-shadow">Gravar</el-button>
            <el-button @click="fechar" round type="danger" size="small" class="btn-box-shadow">Fechar</el-button>
          </el-row>
        </el-col>
      </el-row>
    </span>

    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaDialog" :visibility="visibilidadeSelecionarContaBancariaDialog" todosOsBancos/>

  </el-dialog>
</template>

<script>
import { Money } from "v-money";
import { mapState, mapActions } from "vuex";
import { TIPO_LANCAMENTO, BANCOS } from "../../../util/constantes";

import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import funcoes from '../../../util/funcoes';
import { validadorData } from "../../../util/validadores"

export default {
  components: {
    AppSelecionarContaBancariaDialog,

    Money
  },
  props: {
    visibility: Boolean
  },
  data() {
    return {
      visibilidadeSelecionarContaBancariaDialog: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      lancamento: {
        id: 0,
        conta: { id: 0 },
        contaBancaria: { id: 0 },
        status: 'ABERTO',
        dataPagamento: funcoes.hoje()
      },

       validacao: {
        tipo: [{ required: true }],
        dataVencimento: [{ validadorData ,required: true }],
        valor: [{ type: "number", min: 0.01 }],
        bancoCheque: [{ required: true }],
        agenciaCheque: [{ required: true }],
        numeroCheque: [{ required: true }]
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "LANCAMENTOS_CONTAS_RECEBER"
          })[0];
      }
    }),
    ...mapState('contasReceberStore', {
      conta(state) { return state.contaReceberSelecionado },
      lancamentoSelecionado(state) { return state.lancamentoSelecionado }
    }),

    bancos() {
      return BANCOS;
    },
    tiposLancamento(){
      return TIPO_LANCAMENTO
    },
    nomeContaBancaria(){
      return this.lancamentoSelecionado.contaBancaria ? this.lancamentoSelecionado.contaBancaria.nome : ''
    },
    exibirFormCheque(){
      return this.lancamentoSelecionado.tipo && this.lancamentoSelecionado.tipo === 'CHEQUE'
    },
    exibirBotaoGravar(){
      return (this.lancamentoSelecionado.id === 0 && this.permissoes.cadastro) || (this.lancamentoSelecionado.id !== 0 && this.permissoes.alteracao && this.lancamentoSelecionado.status === 'ABERTO')
    },
    exibirBotaoPagar(){
      return this.lancamentoSelecionado.id !== 0 && this.permissoes.pagarLancamento && this.lancamentoSelecionado.status === 'ABERTO'
    },
    exibirBotaoCancelar(){
      return this.lancamentoSelecionado.id !== 0 && this.permissoes.cancelarLancamento && this.lancamentoSelecionado.status === 'EFETUADO'
    },
    exibirBotaoDevolver(){
      return this.lancamentoSelecionado.id !== 0 && this.lancamentoSelecionado.tipo && this.lancamentoSelecionado.tipo === 'CHEQUE' && this.lancamentoSelecionado.status === 'ABERTO'
    },
    lancamentoIsNovo() {
      return this.lancamentoSelecionado.id === 0
    },
    isLancamentoAberto() {
      return this.lancamentoSelecionado.status === 'ABERTO' && this.lancamentoSelecionado.id !== 0;
    },
    isLancamentoEfetuado() {
      return this.lancamentoSelecionado.status === 'EFETUADO' && this.lancamentoSelecionado.id !== 0;
    },
    dataDepositoIsVisible() {
      return this.lancamentoSelecionado.id != 0;
    },
    disableObsevacoes() {
      return this.lancamentoSelecionado.status === 'EFETUADO';
    },
    remessaIsGerada() {
      return this.lancamentoSelecionado.id != 0 && this.lancamentoSelecionado.sequencialRemessa !== null;
    },
    isExibirInstrucoes() {
      return this.lancamentoSelecionado.tipo === 'BOLETO';
    }
  },

  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("contasReceberStore", [
      "gravarLancamento",
      "pagarLancamento",
      "cancelarPagamentoLancamento",
      "devolverCheque"
    ]),

    gravarHandler(){
      delete this.validacao.valorPago
      delete this.validacao.dataPagamento
      delete this.validacao.dataDeposito
      this.lancamentoSelecionado.conta.id = this.conta.id
      if(this.lancamentoSelecionado.tipo !== 'CHEQUE'){
        delete this.lancamentoSelecionado.bancoCheque
        delete this.lancamentoSelecionado.agenciaCheque
        delete this.lancamentoSelecionado.numeroCheque
      }

      this.$refs['form'].validate(elFormValidate => {
        const formIsInvalid = !elFormValidate;
        if(formIsInvalid) {
          this.$alert('Preencha todos os campos obrigatórios', 'Atenção', { confirmButtonText: 'Ok' })
          return;
        }
          this.gravar();
      })
    },

    gravar() {
      this.showLoading();
      this.gravarLancamento(this.lancamentoSelecionado)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.fechar();
      });
    },

    pagarHandler(){
      this.validacao.valorPago =  [{ type: "number", min: 0.01 }]
      this.validacao.dataPagamento = [{  validator: validadorData, required: true }]
      if(this.lancamentoSelecionado.tipo === 'CHEQUE') { this.validacao.dataDeposito = [{ validator: validadorData, required: true  }] }
      this.lancamentoSelecionado.conta.id = this.conta.id
      if(this.lancamentoSelecionado.tipo !== 'CHEQUE'){
        delete this.lancamentoSelecionado.bancoCheque
        delete this.lancamentoSelecionado.agenciaCheque
        delete this.lancamentoSelecionado.numeroCheque
      }

      this.$refs['form'].validate(elFormvalidate => {
        const formIsInvalid = !elFormvalidate;
        if(formIsInvalid) {
          this.$alert('Preencha todos os campos obrigatórios', 'Atenção', { confirmButtonText: 'Ok' })
          return;
        }
        if(!this.lancamentoSelecionado.contaBancaria) {
          this.$alert('Não é possível pagar o lançamento sem uma conta bancária selecionada.', 'Atenção', { confirmButtonText: 'Ok' })
          return;
        }
          this.pagar();
      });
    },

    pagar() {
      this.showLoading();
      this.pagarLancamento(this.lancamentoSelecionado)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        const payload = { baixouLancamento: true };
        this.fechar(payload);
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.fechar();
      });
    },

    cancelarPagamentoHandler(){
      this.cancelar()
    },

    cancelar() {
      this.showLoading();
      this.cancelarPagamentoLancamento( { id: this.lancamentoSelecionado.id })
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.fechar();
      });
    },

    devolverHandler(){
      this.lancamentoSelecionado.conta.id = this.conta.id
      this.lancamentoSelecionado.status = 'DEVOLVIDO'
      if(this.lancamentoSelecionado.tipo !== 'CHEQUE'){
        delete this.lancamentoSelecionado.bancoCheque
        delete this.lancamentoSelecionado.agenciaCheque
        delete this.lancamentoSelecionado.numeroCheque
      }

      this.devolver()
    },

    devolver() {
      this.showLoading();
      this.devolverCheque(this.lancamentoSelecionado)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.fechar();
      });
    },
    dadosValidos(){
      let valido = true

      valido = valido && this.lancamentoSelecionado.tipo
      valido = valido && this.lancamentoSelecionado.dataVencimento
      valido = valido && this.lancamentoSelecionado.valor

      return valido
    },

    dadosPagamentoValidos(){
      let valido = true

      valido = valido && this.lancamentoSelecionado.dataPagamento
      valido = valido && this.lancamentoSelecionado.valorPago
      valido = valido && (this.lancamentoSelecionado.contaBancaria && this.lancamentoSelecionado.contaBancaria.id !== 0)

      return valido
    },

    // DIALOGS
    exibirSelecionarContaBancariaDialog() { 
      this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) { 
        this.lancamentoSelecionado.contaBancaria = contaBancaria
        this.visibilidadeSelecionarContaBancariaDialog = false; 
    },

    reset() {
      delete this.validacao.valorPago
      delete this.validacao.dataPagamento
      delete this.validacao.dataDeposito
    },

    fechar(payload) {
      this.reset();
      this.$emit('close', payload);
    }, 
  }
}
</script>
